import React from 'react'

import { Color as TColor } from 'themes'

import { useProfileColors } from 'redux/hooks/Customization'
import { useTranslation } from 'language/translator'

import Box from 'components_new/atoms/Box'

import ColorRadio from 'components_new/molecules/ColorRadio'
import FormSection from 'components_new/molecules/FormSection'

interface ColorProps {
  onSubmit: (value: TColor) => void
  value: TColor
}

const Color = (props: ColorProps) => {
  const { onSubmit, value } = props

  const { t } = useTranslation()
  const options = useProfileColors()

  return (
    <FormSection
      helperText={t('groups', 'color_helper_text')}
      importance="recommended"
      size="small"
      title={t('groups', 'color_title')}
    >
      <Box>
        {(Object.keys(options) as TColor[]).map((option) => (
          <ColorRadio
            value={option}
            checked={option === value}
            color={option}
            key={option}
            onChange={() => onSubmit(option)}
          />
        ))}
      </Box>
    </FormSection>
  )
}

export default Color
